import Swiper from 'swiper';
import {
  Parallax,
  Scrollbar,
  Controller,
  Manipulation,
  Navigation
} from 'swiper/modules';

export default () => ({
  swiper: null,

  async init() {
    const SwiperDefaultOptions = {
      modules: [Parallax, Scrollbar],
      navigation: false
    };

    const thumbSwiper = new Swiper(this.$refs.thumbSlider, {
      slidesPerView: 1,
      spaceBetween: 40,
      modules: [Parallax, Scrollbar, Manipulation, Controller],
      navigation: {
        enabled: false
      }
    });

    thumbSwiper.removeSlide(0);

    const swiper = new Swiper(this.$refs.slider, {
      slidesPerView: 1,
      modules: [Parallax, Scrollbar, Controller, Navigation],
      navigation: {
        prevEl: this.$refs.prev,
        nextEl: this.$refs.next
      },
      scrollbar: {
        el: this.$refs.scrollbar
      }
    });

    thumbSwiper.controller.control = swiper;
    swiper.controller.control = thumbSwiper;
  }
});
